<template>
    <div class="biz-house-mgt-list">
        <div class="house-list">
            <house-card  v-for="(houseItem,index) in houseMgtList" :key="index" :house="houseItem"></house-card>
            <transition name="fade">
                <house-card v-if="HmgtIsLoading"></house-card>
            </transition>
            <transition name="fade">
                <house-card v-if="HmgtIsLoading"></house-card>
            </transition>
            <transition name="fade">
                <house-card v-if="HmgtIsLoading"></house-card>
            </transition>
            <transition name="fade">
                <house-card v-if="HmgtIsLoading"></house-card>
            </transition>
            <transition name="fade">
                <house-card v-if="HmgtIsLoading"></house-card>
            </transition>
            <transition name="fade">
                <house-card v-if="HmgtIsLoading"></house-card>
            </transition>
            <transition name="fade">
                <house-card v-if="HmgtIsLoading"></house-card>
            </transition>
            <transition name="fade">
                <house-card v-if="HmgtIsLoading"></house-card>
            </transition>
            <div class="no-house" v-if="houseMgtList.length == 0 && !HmgtIsLoading">
                <img src="@/assets/img/state/hmgt_no_house.svg" alt="">
                0 筆資料，尚未新增任何房源
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HouseCard from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/graphMode/HouseCard.vue';
// import {
//     apiGetHouseMgtList
//     } from "@/apis/api.js";
export default {
    data () {
        return {
            // houseMgtList: [],
            filterEmpty: false,
            houseMgtDataEmpty: false,
            houseMgtDataError: false,
            isLoading: false,
            model: 1,
            filterTotal: {
                all: 0,
                rented: 0,
                rent: 0,
            },
        }
    },
    props: {
        state: ''
    },
    /*
    mounted () {
        // this.getHouseMgtList()
        this.$store.dispatch('getBizHouseMgtList')
    },
    */
    watch: {
        // apiStatus: function () {
        //     if( this.apiStatus == 'update' ){
        //         this.getHouseMgtList()
        //     }
        // }
        // HmgtIsLoading: function () {},
        // filterByWord:{
        //     handler: function (val) {
        //         if( this.state == 0 ){
        //             this.$store.dispatch('setBizHouseMgtFilterResultTotal', {type: 'all', count: val.length})
        //         }else if( this.state == 1 ){
        //             this.$store.dispatch('setBizHouseMgtFilterResultTotal', {type: 'rented', count: val.length})
        //         }else if( this.state == 2 ){
        //             this.$store.dispatch('setBizHouseMgtFilterResultTotal', {type: 'rent', count: val.length})
        //         }
        //     },
        //     immediate: true,
        //     deep: true
        // }
    },
    methods: {
        // setFilterTotal: function () {
        //     if( this.state == 0 ){
        //         this.filterTotal.all = val.length
        //     }else if( this.state == 1 ){
        //         this.filterTotal.rented = val.length
        //     }else if( this.state == 2 ){
        //         this.filterTotal.rent = val.length
        //     }
        // },
        // isHaveTenant: function (array, filter) {
        //     for (let i = 0; i < array.length; i++) {
        //         const element = array[i];
        //         if(element.tenantName.includes(filter)){
        //             return true
        //         }
        //     }
        // }
    },
    computed: {
      /*
        filterByState: function () {
            return this.houseMgtList.filter((houseItem) => {
                // console.log(houseItem)
                if( this.state == 0 ){
                    return houseItem
                }else if( this.state == 1 ){
                    if( houseItem.empty == 0 ){
                        return houseItem
                    }
                }else if( this.state == 2 ){
                    if( houseItem.empty == 1 ){
                        return houseItem
                    }
                }
            });
        },
        filterByGroup: function () {
            return this.filterByState.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.agentName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByCounty: function () {
            return this.filterBySales.filter((houseItem) => {
                if(this.filterQuery.county){
                    if(houseItem.county === this.filterQuery.county){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((houseItem) => {
                if( this.filterQuery.district){
                    if(houseItem.district === this.filterQuery.district){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByRent: function () {
            return this.filterByDistrict.filter((houseItem) => {
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[1] >= 100000){
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice){
                            return houseItem
                        }
                    }else{
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice && this.filterQuery.rent[1] >= houseItem.rentPrice ){
                            return houseItem
                        }
                    }

                }else{
                    return houseItem
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByRent.filter((houseItem) => {
                if( this.filterQuery.houseType ){
                    if( this.filterQuery.houseType == houseItem.houseType ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByBuildingType: function () {
            return this.filterByHouseType.filter((houseItem) => {
                if( this.filterQuery.buildingType ){
                    if( this.filterQuery.buildingType == houseItem.buildingType ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByCompleted: function () {
            return this.filterByBuildingType.filter((houseItem) => {
                // console.log(this.filterQuery.completed)
                // console.log(houseItem.complete)
                if( this.filterQuery.completed ){
                    if( this.filterQuery.completed  == 'completed' && houseItem.complete == true){
                        return houseItem
                    }else if( this.filterQuery.completed  == 'noCompleted' && houseItem.complete == false){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByPublish: function () {
            return this.filterByCompleted.filter((houseItem) => {
                if( this.filterQuery.publish ){
                    if( this.filterQuery.publish == 'publish' && houseItem.publish == true ){
                        return houseItem
                    }else if( this.filterQuery.publish == 'noPublish' && houseItem.publish == false ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByWord: function () {
            return this.filterByPublish.filter((houseItem) => {
                if( this.filterWord ){
                    if( houseItem.houseName.includes(this.filterWord) || houseItem.address.includes(this.filterWord) || houseItem.landlordName != null && houseItem.landlordName.includes(this.filterWord) || this.isHaveTenant(houseItem.inProgressContractList, this.filterWord) ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByEmpty: function () {
            return this.filterByWord.filter((houseItem) => {
                if( this.state == 0 ){
                    return houseItem
                }else if( this.state == 1 ){
                    if( houseItem.empty == 0){
                        return houseItem
                    }
                }else if( this.state == 2 ){
                    if( houseItem.empty == 1){
                        return houseItem
                    }
                }
            });
        },
        // 有無限迴圈問題 待修
        filterResult: function () {
            return this.filterByWord.filter((houseItem) => {
                        this.$store.dispatch('setBizHouseMgtFilterResultTotal', this.filterByWord.length)
                        // return houseItem
                // if( this.houseMgtDataEmpty == false && this.houseMgtDataError == false && this.isLoading == false ){
                //     if( this.filterByWord.length == 0 ){
                //         // this.filterEmpty = true
                //         this.$store.dispatch('setHouseMgtFilterResultTotal', 0)
                //     }else{
                //         console.log(this.filterByWord.length)
                //         // this.filterEmpty = false
                //         this.$store.dispatch('setHouseMgtFilterResultTotal', this.filterByWord.length)
                //         return this.filterByWord
                //     }
                // }
            });
        },
       */
        ...mapGetters({
            filterWord: 'GET_BIZ_HOUSE_MGT_FILTER_WORD',
            filterQuery: 'GET_BIZ_HOUSE_MGT_FILTER_QUERY',
            houseMgtList: 'GET_BIZ_HOUSE_MGT_LIST',
            apiStatus: 'GET_STATUS',
            HmgtIsLoading: 'GET_BIZ_HOUSE_MGT_LOADING'
        })
    },
    components: {
        HouseCard,
    }
}
</script>
<style lang="scss">
    .biz-house-mgt-list{
        min-width: 1174px;
        .house-list{
            position: relative;
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 0px !important;
            .biz-house-card{
                margin-bottom: 19px;
            }
            .biz-house-card:nth-child(odd){
                margin-right: 19px;
            }
            .no-house{
                width: 100%;
                margin-top: 40px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img{
                    margin-bottom: 30px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/houseMgt/graphMode/HouseMgtGraph.vue